import { rem } from "polished";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { baseButtonStyle } from "@/components/editor/themes/crosby/constants";

export const Wrapper = styled.div`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};

  h3,
  p {
    margin-bottom: 0;
  }
`;

export const CTAButtonWrapper = withViewportStyle("div")`
  .button-primitive {
    ${baseButtonStyle}
    max-width: ${rem(300)};
    
    ${(props) => props.$viewport.mobile`
      max-width: 100%;
      width: 100%;
    `}
  }
`;
